/**
 * Vuex 容器
 *    获取方便
 *    响应式的
 * 本地存储
 *    持久化
 */

import Vue from 'vue'
import Vuex from 'vuex'
import { getItem, setItem } from '@/utils/storage'
// import decodeJwt from 'jwt-decode'

const USER_KEY = 'user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    backAdress: '',
    adress: getItem('adress'),
    user: getItem(USER_KEY), // 当前登录用户状态（token）
    // user: JSON.parse(window.localStorage.getItem('user')) // 当前登录用户状态（token）
    // user: null // 当前登录用户状态（token）
    carrerTouScroll: {
      height: '' // 滚动的距离
    }
  },
  mutations: {
    // 登录成功和退出登录都会调用
    // state = 视图数据   data = 要接受的参数
    setUser (state, data) {
      // if (data && data.token) {
      //   data.id = decodeJwt(data.token).user_id
      // }
      state.user = data
      // 为了避免页面刷新数据丢失，我们这里使用本地存储进行 **持久化**
      setItem(USER_KEY, state.user)
      // window.localStorage.setItem('user', JSON.stringify(state.user))
    },
    setAdress (state, data) {
      state.address = data
      setItem('adress', state.address)
    },
    setCarrerTouScroll (state, disdance) { // 管理赛事 滚动距离
      state.carrerTouScroll.height = disdance
    }
  },
  getters: {
    getCarrerTou: state => state.carrerTouScroll
  },
  actions: {
  },
  modules: {
  }
})
